import React from 'react';
import {Form, Space, Typography} from "antd";

const DG_FormItem_LabelDetail = props => {
    const label = props.label;
    const labelDetail = props?.labelDetail;
    const subLabelDetails = labelDetail.split("\n");
    const subProps = {...props}
    delete (subProps.label)
    delete (subProps.labelDetail)

    return (
        <>
            <div >
                <Form.Item
                    label={
                        <Space
                            direction="vertical"
                        >
                            <>
                            <span className={'font-bold'}>
                                {label}
                            </span>
                                {subLabelDetails.map(item =>
                                    <span>
                                    {item}
                                </span>)}
                                <div>{props?.showRules}</div>
                            </>
                        </Space>
                    }
                    labelCol={{xxl: {span: 19}, xl: {span: 19}, lg: {span: 24}} || props.labelCol}
                    wrapperCol={{xxl: {span: 5}, xl: {span: 5}, lg: {span: 24}} || props.wrapperCol}
                    colon={false}
                    labelAlign={"left"}
                    style={props.style || {height: "auto"}}
                    {...subProps}
                >
                    {props.children}
                </Form.Item>
            </div>
        </>
    )
};

export default DG_FormItem_LabelDetail;
